import { WorkType } from '@/types/jobs';
import React from 'react';

import CheckIcon from '@material-ui/icons/Check';

import styles from './WorkTypeCheckboxGroup.module.scss';

export interface WorkTypeCheckboxGroupProps {
  value: WorkType[];
  onChange: (value: WorkType[]) => void;
  id?: string;
}

export const WorkTypeCheckboxGroup = ({
  value,
  onChange,
  id = 'work-type-checkbox-group',
}: WorkTypeCheckboxGroupProps) => {
  const handleCheckboxChange = (optionValue: WorkType, isChecked: boolean) => {
    if (!isChecked) {
      // Remove from array
      onChange(value.filter(v => v !== optionValue));
      return;
    }

    onChange([...value, optionValue]);
  };

  const labelId = `${id}-label`;

  return (
    <div className={styles.workTypeCheckboxGroup}>
      <div className={styles.label} id={labelId}>
        Interested in
      </div>
      <div className={styles.checkboxContainer} role="group" aria-labelledby={labelId}>
        {/* Locum Checkbox */}
        <label className={styles.checkboxLabel} htmlFor={`${id}-locum`}>
          <input
            type="checkbox"
            id={`${id}-locum`}
            checked={value.includes('Locum')}
            onChange={e => handleCheckboxChange('Locum', e.target.checked)}
            className={styles.hiddenCheckbox}
          />
          <span className={styles.labelText}>Locum</span>
          <span className={styles.customCheckbox}>
            {value.includes('Locum') && <CheckIcon className={styles.checkIcon} />}
          </span>
        </label>

        {/* Permanent Checkbox */}
        <label className={styles.checkboxLabel} htmlFor={`${id}-permanent`}>
          <input
            type="checkbox"
            id={`${id}-permanent`}
            checked={value.includes('Permanent')}
            onChange={e => handleCheckboxChange('Permanent', e.target.checked)}
            className={styles.hiddenCheckbox}
          />
          <span className={styles.labelText}>Permanent</span>
          <span className={styles.customCheckbox}>
            {value.includes('Permanent') && <CheckIcon className={styles.checkIcon} />}
          </span>
        </label>
      </div>
    </div>
  );
};

export default WorkTypeCheckboxGroup;
